import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import PublicLogoLink from "./PublicLogoLink";
import Reveal from "./ui/Reveal";

export default function PublicPageHeader({
  title,
  subtitle,
  action,
  titleVariant = "h3",
  visualVariant = undefined,
  sx = {},
  logoMaxWidth = { xs: 180, sm: 220, md: 260 },
  logoAction = null,
}) {
  return (
    <Reveal>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "flex-end" },
          justifyContent: "space-between",
          gap: { xs: 2, sm: 3 },
          mb: { xs: 4, md: 7 },
          width: "100%",
          ...sx,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {title && (
            <Typography
              variant={titleVariant}
              component="h1"
              sx={{ lineHeight: 1.08, letterSpacing: "-0.024em" }}
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ maxWidth: "62ch", fontSize: "1.0625rem" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        <Stack
          spacing={0.25}
          alignItems={{ xs: "center", sm: "flex-end" }}
          sx={{
            order: { xs: -1, sm: 0 },
            alignSelf: { xs: "center", sm: "flex-end" },
            mb: { xs: 1, sm: 0 },
            ml: { sm: "auto" },
          }}
        >
          <PublicLogoLink maxWidth={logoMaxWidth} />
          {logoAction}
        </Stack>
        {action && (
          <Box
            sx={{
              mt: { xs: 1, sm: 0 },
              order: { xs: 2, sm: 0 },
              alignSelf: { xs: "flex-start", sm: "flex-end" },
            }}
          >
            {action}
          </Box>
        )}
      </Box>
    </Reveal>
  );
}
